// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function () {
  initializeSearchReset();
});

// Also handle case where script loads after DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading
  document.addEventListener('DOMContentLoaded', initializeSearchReset);
} else {
  // DOM is already loaded
  initializeSearchReset();
}

function initializeSearchReset() {
  // Use a more specific selector for the reset button in header search modal
  const resetButton = document.querySelector('.header__search .reset__button');
  const searchInputs = document.querySelectorAll('.header__search .search__input');

  if (resetButton) {
    resetButton.addEventListener('click', function () {
      // Clear all search inputs when reset button is clicked
      const allSearchInputs = document.querySelectorAll('input[type="search"]');
      allSearchInputs.forEach((input) => {
        input.value = '';
      });

      // Also hide all reset buttons since inputs are now empty
      document.querySelectorAll('.reset__button').forEach((button) => {
        button.classList.add('hidden');
      });
    });
  }

  // Add keydown listener for backspace/delete in header search inputs
  searchInputs.forEach((input) => {
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        // Use setTimeout to ensure input value has been updated
        setTimeout(() => {
          // Clear all search inputs when backspace/delete is pressed on empty input
          if (event.target.value === '') {
            document.querySelectorAll('input[type="search"]').forEach((searchInput) => {
              searchInput.value = '';
            });
          } else {
            // Sync the updated value to other inputs
            const allSearchInputs = document.querySelectorAll('input[type="search"]');
            allSearchInputs.forEach((searchInput) => {
              if (searchInput !== event.target) {
                searchInput.value = event.target.value;
              }
            });
          }
        }, 10);
      }
    });
  });

  if (!resetButton) {
    // If reset button not found, try again after a short delay
    setTimeout(initializeSearchReset, 100);
  }
}
